var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DAC6E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12,
    r: 0.75,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.75,
    stroke: "#272932",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12,
    r: 0.75,
    stroke: "#272932",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.1574d0a464a17573cd917e21bc7de940.svg";
export { ForwardRef as ReactComponent };